module.exports = __webpack_public_path__ + "media/images/country_flags/gi-1f095eea3ce67fa9874faf25c1b8073f.png";